import React, { useState } from 'react';
import { Box, FormControl, IconButton } from '@mui/material';
import CustomSelect from 'app/components/CustomSelect';
import CustomInput from 'app/components/CustomInput';
import BankCodeIcon from 'app/components/Icons/BankCodeIcon';
import CustomSwitch from 'app/components/CustomSwitch';
import BankDataModal from 'app/components/AccordionTypes/Country/BankDataModal';
import FieldError from 'app/components/FieldError';

interface Props {
  register?: any;
  control?: any;
  errors?: any;
  countries?: any;
  selectedCountry?: any;
  handleChangeCountry?: any;
  mediatorBank?: any;
  handleSwitchMediatorBank?: any;
  openDialogSwiftBic?: any;
  setOpenDialogSwiftBic?: any;
  openMediatorDialogSwiftBic?: any;
  setOpenMediatorDialogSwiftBic?: any;
  transferData?: any;
  setIsSearch?: any;
  bankCode?: any;
  getSwiftCode?: any;
  handleClickSwiftCode?: any;
  handleClickMediatorSwiftCode?: any;
  dataForm?: any;
  handleSearchMediatorSwift?: any;
  handleSearchSwift?: any;
  setSwiftMediatorCodeForeign?: any;
  setSwiftCodeForeign?: any;
  selectedFromAccount?: any;
  dataSwiftCode?: any;
  innForeign?: any;
  kppForeign?: any;
  beneficiarNameForeign?: any;
  beneficiarAddressForeign?: any;
  handleChangeInnForeign?: any;
  handleChangeKppForeign?: any;
  handleChangeBeneficiarNameForeign?: any;
  handleChangeBeneficiarAddressForeign?: any;
}

const GeneralDetailsAbroad = (props: Props) => {
  const {
    register,
    errors,
    control,
    handleChangeCountry,
    countries,
    selectedCountry,
    handleSwitchMediatorBank,
    mediatorBank,
    openDialogSwiftBic,
    setOpenDialogSwiftBic,
    openMediatorDialogSwiftBic,
    setOpenMediatorDialogSwiftBic,
    setIsSearch,
    getSwiftCode,
    handleClickSwiftCode,
    transferData,
    bankCode,
    handleClickMediatorSwiftCode,
    dataForm,
    handleSearchMediatorSwift,
    handleSearchSwift,
    setSwiftMediatorCodeForeign,
    setSwiftCodeForeign,
    selectedFromAccount,
    dataSwiftCode,
    innForeign,
    kppForeign,
    beneficiarNameForeign,
    beneficiarAddressForeign,
    handleChangeInnForeign,
    handleChangeKppForeign,
    handleChangeBeneficiarNameForeign,
    handleChangeBeneficiarAddressForeign,
  } = props;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <Box
        sx={{
          display: 'flex',
          gap: '28px',
          width: '100%',

          '@media screen and (max-width: 768px)': {
            flexDirection: 'column',
            width: '100%',
          },
        }}
      >
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomSelect
            title={'Benefisiarın ölkəsi'}
            placeholder={'Benefisiarın ölkəsi'}
            options={countries}
            value={selectedCountry}
            onChange={handleChangeCountry}
            control={control}
            rest={{ ...register('country') }}
            isSearchable={true}
            isValid={errors.country !== undefined || dataForm?.error?.fields.country_code !== undefined}
          />
          <FieldError
            error={
              errors.country
                ? errors.country
                : dataForm?.error?.fields.bank_bic_code && { message: dataForm?.error?.fields.country_code }
            }
          />
        </FormControl>
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomInput
            title={'Benefisiar bankın Swift/BIC kodu'}
            placeholder={'Benefisiar bankın/Swift BIC kodu'}
            rest={{ ...register('swiftBic') }}
            disabled={selectedCountry?.value === undefined || selectedFromAccount === undefined}
            handleChange={handleSearchSwift}
            handleFocus={() => setSwiftCodeForeign(true)}
            handleBlur={() => setSwiftCodeForeign(false)}
            adornment={
              <IconButton
                onClick={() => {
                  if (selectedCountry?.value !== undefined && selectedFromAccount !== undefined) {
                    setOpenDialogSwiftBic(true);
                  }
                }}
              >
                <BankCodeIcon />
              </IconButton>
            }
            isValid={errors.swiftBic !== undefined || dataForm?.error?.fields.bank_bic_code !== undefined}
          />
          <FieldError
            error={
              errors.swiftBic
                ? errors.swiftBic
                : dataForm?.error?.fields.bank_bic_code && { message: dataForm?.error?.fields.bank_bic_code }
            }
          />
        </FormControl>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: '28px',
          width: '100%',

          '@media screen and (max-width: 768px)': {
            flexDirection: 'column',
            width: '100%',
          },
        }}
      >
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomInput
            title={'Benefisiar bankın adı'}
            placeholder={'Benefisiar bankın adı'}
            disabled={true}
            rest={{ ...register('beneficiarBankName') }}
          />
        </FormControl>
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomInput
            title={'Benefsiarın hesab nömrəsi'}
            placeholder={'Benefsiarın hesab nömrəsi'}
            rest={{ ...register('beneficiarAccNumber') }}
            isValid={errors.beneficiarAccNumber !== undefined || dataForm?.error?.fields.cr_acc_no !== undefined}
          />
          <FieldError
            error={
              errors.beneficiarAccNumber
                ? errors.beneficiarAccNumber
                : dataForm?.error?.fields.cr_acc_no && { message: dataForm?.error?.fields.cr_acc_no }
            }
          />
        </FormControl>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: '28px',
          width: '100%',

          '@media screen and (max-width: 768px)': {
            flexDirection: 'column',
            width: '100%',
          },
        }}
      >
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomInput
            title={'Benefisiarın adı'}
            placeholder={'Benefisiarın adı'}
            rest={{ ...register('beneficiarName'), maxLength: 34 }}
            isValid={errors.beneficiarName !== undefined || dataForm?.error?.fields.cr_name !== undefined}
            handleChange={handleChangeBeneficiarNameForeign}
            value={beneficiarNameForeign}
          />
          <FieldError
            error={
              errors.beneficiarName
                ? errors.beneficiarName
                : dataForm?.error?.fields.cr_name && { message: dataForm?.error?.fields.cr_name }
            }
          />
        </FormControl>
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomInput
            title={'Benefisiarın ünvanı'}
            placeholder={'Benefisiarın ünvanı'}
            rest={{ ...register('beneficiarAddress') }}
            isValid={errors.beneficiarAddress !== undefined || dataForm?.error?.fields.cr_address !== undefined}
            handleChange={handleChangeBeneficiarAddressForeign}
            value={beneficiarAddressForeign}
          />
          <FieldError
            error={
              errors.beneficiarAddress
                ? errors.beneficiarAddress
                : dataForm?.error?.fields.cr_address && { message: dataForm?.error?.fields.cr_address }
            }
          />
        </FormControl>
      </Box>
      {/* {selectedCountry?.value !== 'RUS' && ( */}
      {/*   <> */}
      {/*     <CustomSwitch title={'Vasitəçi bank'} checked={mediatorBank} handleToggle={handleSwitchMediatorBank} /> */}
      {/*     {mediatorBank && ( */}
      {/*       <> */}
      {/*         <Box sx={{ display: 'flex', gap: '28px' }}> */}
      {/*           <FormControl> */}
      {/*             <CustomInput */}
      {/*               title={'Vasitəçi bankın Swift BIC kodu'} */}
      {/*               placeholder={'Vasitəçi bankın Swift BIC kodu'} */}
      {/*               rest={{ ...register('midBankSwiftBic') }} */}
      {/*               adornment={ */}
      {/*                 <IconButton onClick={() => setOpenMediatorDialogSwiftBic(true)}> */}
      {/*                   <BankCodeIcon /> */}
      {/*                 </IconButton> */}
      {/*               } */}
      {/*               handleChange={handleSearchMediatorSwift} */}
      {/*               handleFocus={() => setSwiftMediatorCodeForeign(true)} */}
      {/*               handleBlur={() => setSwiftMediatorCodeForeign(false)} */}
      {/*               isValid={errors.midBankSwiftBic !== undefined || dataForm?.error?.fields.int_bank !== undefined} */}
      {/*             /> */}
      {/*             <FieldError */}
      {/*               error={ */}
      {/*                 errors.midBankSwiftBic */}
      {/*                   ? errors.midBankSwiftBic */}
      {/*                   : dataForm?.error?.fields.int_bank && { message: dataForm?.error?.fields.int_bank } */}
      {/*               } */}
      {/*             /> */}
      {/*           </FormControl> */}
      {/*           <FormControl> */}
      {/*             <CustomInput */}
      {/*               title={'Vasitəçi bankın adı'} */}
      {/*               placeholder={'Vasitəçi bankın adı'} */}
      {/*               rest={{ ...register('midBankName') }} */}
      {/*               disabled={true} */}
      {/*             /> */}
      {/*           </FormControl> */}
      {/*         </Box> */}
      {/*         <FormControl> */}
      {/*           <CustomInput */}
      {/*             title={'Vasitəçi bankın hesab nömrəsi'} */}
      {/*             placeholder={'Vasitəçi bankın hesab nömrəsi'} */}
      {/*             rest={{ ...register('midBankAccNumber'), maxLength: 28 }} */}
      {/*             isValid={errors.midBankAccNumber !== undefined || dataForm?.error?.fields.int_acc_no !== undefined} */}
      {/*           /> */}
      {/*           <FieldError */}
      {/*             error={ */}
      {/*               errors.midBankAccNumber */}
      {/*                 ? errors.midBankAccNumber */}
      {/*                 : dataForm?.error?.fields.int_acc_no && { message: dataForm?.error?.fields.int_acc_no } */}
      {/*             } */}
      {/*           /> */}
      {/*         </FormControl> */}
      {/*       </> */}
      {/*     )} */}
      {/*   </> */}
      {/* )} */}
      {openDialogSwiftBic && (
        <BankDataModal
          getCodeData={getSwiftCode}
          codeData={bankCode}
          dialogOpen={openDialogSwiftBic}
          dialogSet={setOpenDialogSwiftBic}
          transferData={transferData}
          clickCode={handleClickSwiftCode}
          setIsSearch={setIsSearch}
          budget={false}
          swiftCode={true}
          country={selectedCountry}
          selectedAccount={selectedFromAccount}
        />
      )}
      {openMediatorDialogSwiftBic && (
        <BankDataModal
          getCodeData={getSwiftCode}
          codeData={bankCode}
          dialogOpen={openMediatorDialogSwiftBic}
          dialogSet={setOpenMediatorDialogSwiftBic}
          transferData={transferData}
          clickCode={handleClickMediatorSwiftCode}
          setIsSearch={setIsSearch}
          budget={false}
          swiftCodeMediator={true}
          country={selectedCountry}
        />
      )}
      {selectedCountry?.value === 'RUS' && (
        <Box
          sx={{
            display: 'flex',
            gap: '28px',
            width: '100%',

            '@media screen and (max-width: 768px)': {
              flexDirection: 'column',
              width: '100%',
            },
          }}
        >
          <FormControl
            sx={{
              width: 'fit-content',
              '@media screen and (max-width: 1100px)': {
                width: 'calc((100% - 28px) / 2)',
              },

              '@media screen and (max-width: 768px)': {
                width: '100%',
              },
            }}
          >
            <CustomInput
              title={'Benefisiar İNN (ИНН)'}
              placeholder={'Benefisiar İNN (ИНН)'}
              rest={{ ...register('beneficiarInn'), maxLength: 12 }}
              isValid={errors.beneficiarInn !== undefined || dataForm?.error?.fields.ru_inn !== undefined}
              value={innForeign}
              handleChange={handleChangeInnForeign}
            />
            <FieldError
              error={
                errors.beneficiarInn
                  ? errors.beneficiarInn
                  : dataForm?.error?.fields.ru_inn && { message: dataForm?.error?.fields.ru_inn }
              }
            />
          </FormControl>
          <FormControl
            sx={{
              width: 'fit-content',
              '@media screen and (max-width: 1100px)': {
                width: 'calc((100% - 28px) / 2)',
              },

              '@media screen and (max-width: 768px)': {
                width: '100%',
              },
            }}
          >
            <CustomInput
              title={'Benefisiar KPP (КПП)'}
              placeholder={'Benefisiar KPP (КПП)'}
              rest={{ ...register('beneficiarKpp'), maxLength: 9 }}
              isValid={errors.beneficiarKpp !== undefined || dataForm?.error?.fields.ru_kpp !== undefined}
              value={kppForeign}
              handleChange={handleChangeKppForeign}
            />
            <FieldError
              error={
                errors.beneficiarKpp
                  ? errors.beneficiarKpp
                  : dataForm?.error?.fields.ru_kpp && { message: dataForm?.error?.fields.ru_kpp }
              }
            />
          </FormControl>
        </Box>
      )}
    </Box>
  );
};

export default GeneralDetailsAbroad;
